import { Tag } from 'antd';

export function TagProduto() {
    return (
        <Tag color='blue' variant='outlined'>
            Produto
        </Tag>
    );
}

export function TagPacote() {
    return (
        <Tag color='green' variant='outlined'>
            Pacote
        </Tag>
    );
}
